export { SteelmanNode, $createSteelmanNode, $isSteelmanNode } from './nodes/SteelmanNode';
export type { SteelmanPayload, SerializedSteelmanNode } from './nodes/SteelmanNode';

export { ExplainerNode, $createExplainerNode, $isExplainerNode } from './nodes/ExplainerNode';
export type { ExplainerPayload, SerializedExplainerNode } from './nodes/ExplainerNode';

export { PremiseNode, $createPremiseNode, $isPremiseNode } from './nodes/PremiseNode';
export type { PremisePayload, SerializedPremiseNode } from './nodes/PremiseNode';

export { PerspectiveToggleNode, $createPerspectiveToggleNode, $isPerspectiveToggleNode } from './nodes/PerspectiveToggleNode';
export type { PerspectiveTogglePayload, PerspectiveInfo, SerializedPerspectiveToggleNode } from './nodes/PerspectiveToggleNode';

import type { Klass, LexicalNode } from 'lexical';
import { SteelmanNode } from './nodes/SteelmanNode';
import { ExplainerNode } from './nodes/ExplainerNode';
import { PremiseNode } from './nodes/PremiseNode';
import { PerspectiveToggleNode } from './nodes/PerspectiveToggleNode';

export const PerspectivesNodes: Array<Klass<LexicalNode>> = [
  SteelmanNode,
  ExplainerNode,
  PremiseNode,
  PerspectiveToggleNode,
];
